import { render, staticRenderFns } from "./Trainyuding.vue?vue&type=template&id=03abf5b6&scoped=true"
import script from "./Trainyuding.vue?vue&type=script&lang=js"
export * from "./Trainyuding.vue?vue&type=script&lang=js"
import style0 from "./Trainyuding.vue?vue&type=style&index=0&id=03abf5b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03abf5b6",
  null
  
)

export default component.exports